module.exports = __webpack_public_path__ + "static/media/plr.51ca6516.svg";